import { Button, ErrorAlert, Header, EyeIcon, LinkBtn } from "@";
import { useWatch } from "react-hook-form";
import { useCharity } from "@/shared/hooks/useCharity";
import { useLandingPageForm } from "../../hooks/index";
import {
  GeneralSettingsSection,
  ProjectSelectionSection,
  ThemeSelectionSection,
} from "../../components/form-sections";
import { useCanShow } from "@/shared/hooks";

const Page = () => {
  const {
    register,
    setValue,
    control,
    errors,
    handleSubmit,
    isSubmitting,
    edit,
    show,
    error,
    links,
    submit,
  } = useLandingPageForm();

  const slug = (useWatch({ control, name: "slug" }) as string) ?? "";
  const { charityStoreUrl } = useCharity();
  const previewBase = (charityStoreUrl ?? "").replace(/\/$/, "");
  const canPreview =
    !!previewBase && previewBase !== "#" && !!slug && (!!edit || !!show);

  const canEdit = useCanShow("editSitePages");

  return (
    <>
      <ErrorAlert show={error} />

      <Header
        flex
        title={`${
          edit ? "تعديل صفحة هبوط" : show ? "عرض صفحة هبوط" : "اضافة صفحة هبوط"
        }`}
        links={links}
      >
       <div className="flex items-center gap-2">
       {canPreview && (
          <a
            href={`${previewBase}/lp/${slug}`}
            target="_blank"
            rel="noreferrer"
            className="btn-white gap-1.5"
          >
            <EyeIcon className="size-5" aria-hidden />
            معاينة
          </a>
        )}
        {show && canEdit && <LinkBtn to={`/website/landing-pages/${show}/edit`} edit />}
       </div>
      </Header>

      <form onSubmit={handleSubmit(submit)} className="space-y-5">
        <GeneralSettingsSection
          register={register}
          setValue={setValue}
          control={control}
          errors={errors}
          show={show}
        />

        <ProjectSelectionSection
          setValue={setValue}
          control={control}
          errors={errors}
          show={show}
        />

        <ThemeSelectionSection
          setValue={setValue}
          control={control}
          errors={errors}
          show={show}
        />

        {!show && canEdit && (
          <div className="floating-btn">
            <Button
              className="w-full"
              isLoading={isSubmitting}
              type="submit"
              title="حفظ صفحة الهبوط"
            />
          </div>
        )}
      </form>
    </>
  );
};

export default Page;
